import ReactDOM from "react-dom";
import { LanguageList, ManageChannelsModal } from "../page-components/settings";
import BaseComponent from "./BaseComponent";
import Button from "./Button";
import LocaleImportCSV from "../widgets/dialogs/LocaleImportCSV";
import ReferenceableNodeGroup from "./ReferenceableNodeGroup";
import UnusedPromptsNodeGroup from "./UnusedPromptsNodeGroup";
import { getGlobalSettings } from "../stores";
import { ChannelSelector, LanguageSelector } from "../form_features";
import LocalModuleNodeGroup from "./LocaleModuleNodeGroup";

export default class Locale extends BaseComponent {
    /**
     * Locale
     * @module Locale
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            isLanguageModalOpen: false,
            referenceablePrompts: this.props.referenceablePrompts,
            isChannelModalOpen: false
        };
    }

    forceRerender = () => {
        this.forceUpdate();
    };
    
    componentWillReceiveProps(nextProps) {
        if(nextProps.referenceablePrompts !== this.state.referenceablePrompts) {
            this.setState({referenceablePrompts: nextProps.referenceablePrompts});
        }
    }

    setConfig(key) {
        const modIndex = window.apm.getAttachments("module").findIndex(element => element.id === key);
        if (modIndex !== -1) {
            window.apm.getAttachments("module")[modIndex] = voice;
            window.apm.setSerializedChanged();
        }
    }

    getConfig(key) {
        if (key === "lang") {
            return getGlobalSettings().language;
        }
        else {
            const modIndex = window.apm.getAttachments("module").findIndex(element => element.id === key);
            if (modIndex !== -1) {
                return window.apm.getAttachments("module")[modIndex];
            }
        }
    }

    getPromptNodes(module){
        let prompts=[];
        
        module.versions[1].flow.nodes.forEach((n) => {
            const promptIndex = prompts.findIndex(p => p.props.parentComponentID === n.props.parentComponentID);

            if (n._class === "PromptNodeModel" && promptIndex === -1) {
                prompts.push(n);
            }
            n.props.config.inputs = n.props.config.inputs || [];

            if (n._class === "ModuleNodeModel" && n.props.config.inputs.length > 0) {
                const parentModule = window.apm.getAttachments("module").find(m => m.id === n.props.parentComponentID);
                if (parentModule) {
                    const localVariables = parentModule.localVariables;
                    localVariables.forEach((lv) => {
                        if (lv.props.config.type === "PROMPT") {
                            const moduleInputIndex = n.props.config.inputs.findIndex(input => input.argumentName === `mod.${lv.name}`);
                            if (moduleInputIndex !== -1 && n.props.config.inputs[moduleInputIndex].type === "value" && n.props.config.inputs[moduleInputIndex].value !== "") {
                                const parentPrompt = window.apm.getAttachments("object").find(ob => ob.name === n.props.config.inputs[moduleInputIndex].value && ob.props.nodeTypeName === "Prompt");
                                if (parentPrompt) {
                                    const parentPromptIndex = prompts.findIndex(p => p.props.parentComponentID === parentPrompt.id || p.id === parentPrompt.id);
                                    if (parentPromptIndex === -1) {
                                        prompts.push(parentPrompt);
                                    }
                                }
                            }
                        }
                    });
                }
            }
        });
        
        return prompts;
    }

    render() {
        const { isOmniChannel } = window.apm.serialized.omniChannel;
        const { language, voice, channel, setSettings } = getGlobalSettings();

        const {
            serialized
        } = this.props;
        const {
            isChannelModalOpen,
            isLanguageModalOpen
        } = this.state;

        return (
            <div>
                <div className={"row align-items-end"}>
                    <div className={"col-md-4"} style={{ paddingTop: "6px" }}>
                        <LanguageSelector onChange={this.forceRerender} />
                        <Button
                            context={this}
                            label={window.l.toolbar.manage_languages}
                            asLink={true}
                            callback={() => {
                                this.setState({ isLanguageModalOpen: true });
                            }}
                        />
                        <LanguageList
                            isOpen={isLanguageModalOpen}
                            onChange={this.forceRerender}
                            onComplete={() => {
                                this.setState({ isLanguageModalOpen: false });
                            }}
                        />
                    </div>

                    <div className={"col-md-3"} style={{ paddingTop: "6px" }}>
                        {(!isOmniChannel) ? null : (
                            <>
                                <ChannelSelector onChange={this.forceRerender} />
                                <Button
                                    asLink={true}
                                    callback={() => {
                                        this.setState({ isChannelModalOpen: true });
                                    }}
                                    label="Manage Channels"
                                />
                                <ManageChannelsModal
                                    isOpen={isChannelModalOpen}
                                    onComplete={(newRootSettings) => {
                                        if (newRootSettings) {
                                            this.props.context.setConfig("rootSettings", newRootSettings);
                                            const { channels, defaultChannel } = newRootSettings;
                                            if (!(channel in channels)) {
                                                setSettings({ channel: defaultChannel });
                                            }
                                        }

                                        this.setState({ isChannelModalOpen: false });
                                    }}
                                    serialized={serialized}
                                />
                            </>
                        )}
                    </div>

                    <div className={"col-md-5 container-align-right"}>
                        <Button label={"+"} type={"small"} desc={"Import CSV"}
                            callback={() => {
                                window.apm.popup(window.l.settings.csv_data,
                                    '<div class="custom_script_container"></div>',
                                    '<button class="w2ui-btn secondary" onclick="w2popup.close();">' + window.l.popup.close + '</button> ' +
                                    '<button class="w2ui-btn primary add-button">' + window.l.popup.upload_csv + '</button> ',
                                    [
                                        ".custom_script_container",
                                        () => {
                                            ReactDOM.render(
                                                <LocaleImportCSV />,
                                                $(".custom_script_container").get(0),
                                            );
                                            $(".w2ui-popup").find(".add-button").on("click", function () {
                                                document.dispatchEvent(new CustomEvent("ev-dialog-add"));
                                            });

                                        }

                                    ]

                                );
                            }}
                            context={this}
                        />
                    </div>
                </div>
                <br />
                <div className={"row"}>
                    <div className={"col-md-12"}>
                        {
                            (() => {
                                const moduleNodeGroup = [];

                                this.props.serialized.components.modules.map(mod => {
                                    const prompts = this.getPromptNodes(mod);
                                    if (prompts.length > 0) {
                                        moduleNodeGroup.push(
                                            <LocalModuleNodeGroup context={this}
                                                lang={language}
                                                prompts={prompts}
                                                mod={mod}
                                                valKey={mod.id}
                                                key={mod.id}
                                                voice={voice}
                                                language={language}
                                                channelLayer={channel}
                                            />
                                        );
                                    }
                                });


                                moduleNodeGroup.push(
                                    <ReferenceableNodeGroup context={this}
                                        lang={language}
                                        referenceablePrompts={this.state.referenceablePrompts}
                                        key={"referenceablePrompts"}
                                        voice={voice}
                                        language={language}
                                    />
                                );
                                moduleNodeGroup.push(
                                    <UnusedPromptsNodeGroup context={this}
                                        serialized={this.props.serialized}
                                        lang={language}
                                        key={"unusedPrompts"}
                                        voice={voice}
                                        language={language}
                                    />
                                );
                                return moduleNodeGroup;
                            })()
                        }
                    </div>
                </div>
            </div>
        );
    }
}
